import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';

import { CasinoApi, IntlManager, SiteConfigManager } from '@atlas/core';
import { FreeSpinDetails as FreeSpinDetailsComponent, Icon, Label, Loader } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';

import { ACTIVATED } from './FreeSpins';

const FreeSpinDetails = ({
  freeSpin,
  handleCloseDetails,
  imageUrl,
  linkToGame,
  localizedInfoByLang,
}) => {
  const {
    createTime,
    currency,
    freeSpin: { casinoLimit, numberOfSpins, timeToUse },
    freeSpinAmount,
    status,
  } = freeSpin;
  const history = useHistory();
  const dateFormat = SiteConfigManager.getConfig('config.config.date.dateFormat', 'DD.MM.YYYY');
  const timeFormat = SiteConfigManager.getConfig('config.config.date.timeFormat', 'HH:mm');
  const [gameName, setGameName] = useState('-');
  const [isLoading, setIsLoading] = useState(true);
  const endTime = createTime + timeToUse;

  const expirationTime = useMemo(() => {
    const formattedDate = dayjs(endTime).format(dateFormat);
    const formattedTime = dayjs(endTime).format(timeFormat);

    return `${formattedDate} ${formattedTime}`;
  }, [dateFormat, endTime, timeFormat]);

  useEffect(() => {
    const gameId = casinoLimit.gameIds[0];

    CasinoApi.fetchGameDetailsV2({ gameId })
      .then(res => {
        setGameName(res.game.name);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  const handleButtonClick = useCallback(() => {
    history.push(linkToGame);
  }, [history, linkToGame]);

  return (
    <ModalPortal backdropOff className="freespin-details-modal">
      <div className="profile-wrapper-absolute">
        <button className="back-to-container" onClick={handleCloseDetails} type="button">
          <Icon className="icon-back" name="back" />
          <Label className="title-text" message="freespins" />
        </button>
        <div className="freespin-details-wrapper">
          {isLoading ? (
            <Loader className="relative" />
          ) : (
            <FreeSpinDetailsComponent
              activated={status === ACTIVATED}
              amount={IntlManager.formatMoney(freeSpinAmount)}
              currencies={[currency]}
              description={localizedInfoByLang.description}
              expirationTime={expirationTime}
              gameName={gameName}
              handleButtonClick={handleButtonClick}
              imageUrl={imageUrl}
              name={localizedInfoByLang.name}
              number={numberOfSpins}
              status={status}
              timerTime={endTime}
            />
          )}
        </div>
      </div>
    </ModalPortal>
  );
};

export default FreeSpinDetails;
